module.exports = __webpack_public_path__ + "img/line_2.904ba048.png";